module.exports = __webpack_public_path__ + "static/AH3-mx-bc13489eafa76c363a77b527e0d2b0dc.webp";